var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconInfo = function SvgIconInfo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.18 9.5h1.64V7.82h-1.64zm.82 9.18q-2.812-.078-4.727-1.953Q5.4 14.813 5.32 12q.078-2.812 1.953-4.687Q9.187 5.399 12 5.32q2.813.078 4.688 1.992Q18.602 9.188 18.68 12q-.078 2.812-1.992 4.727Q14.813 18.6 12 18.68m0-15q-3.555.079-5.898 2.422Q3.758 8.446 3.68 12q.079 3.555 2.422 5.899T12 20.32q3.555-.08 5.898-2.422Q20.242 15.555 20.32 12q-.079-3.555-2.422-5.898Q15.555 3.758 12 3.68m-.82 12.5h1.64v-5h-1.64z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconInfo);
export { ForwardRef as ReactComponent };